import * as React from 'react'
import { Form } from 'antd'
import { showError } from 'helpers/errors'
import { HARD_SPACE } from 'helpers/utils'
import { createSetFilterValue } from 'helpers/filters'
import { stopEvent } from 'helpers/events'
import { tryParseMoment, tryParseDate } from 'helpers/dateTime'
import { MonthPicker } from 'elements/DatePicker'
import { t } from 'helpers/i18n'
import Select, { Option, getOptionProps } from 'elements/Select'
import Checkbox from 'elements/Checkbox'
import { Row, Col } from 'elements/Grid'

class Filter extends React.Component {
  constructor(props) {
    super(props)

    this.setFilterValue = createSetFilterValue(this)
  }

  componentDidMount() {
    const { locationGroupIds, locationIds } = this.props.filterDto

    Promise.all([this.props.getLocationGroups(), this.props.getLocations({ locationGroupIds, locationIds })]).catch(
      (error) => showError({ error }),
    )
  }

  render() {
    const { filterDto = {} } = this.props

    return (
      <Form layout="vertical" colon={false} onSubmit={stopEvent}>
        <Row>
          <Col third>
            <Form.Item label={t('locationGroup')}>
              <Select
                onChange={(values) => this.setFilterValue('locationGroupIds', values)}
                placeholder={t('all')}
                value={filterDto.locationGroupIds}
                mode="multiple"
              >
                {(this.props.locationGroups ?? []).map((each) => (
                  <Option key={each.id} value={each.id}>
                    <span {...getOptionProps(each)}>{each.displayName}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label={t('location')}>
              <Select
                onChange={(value) => this.setFilterValue('locationIds', value)}
                mode="multiple"
                placeholder={t('all')}
                value={filterDto.locationIds}
              >
                {(this.props.locations ?? []).map((each) => (
                  <Option key={each.id} value={each.id}>
                    <span {...getOptionProps(each)}>{each.displayName}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col third>
            <Form.Item label={t('month')}>
              <MonthPicker
                className="w-full"
                value={tryParseMoment(filterDto.endDate)}
                onChange={(value) => this.setFilterValue('endDate', tryParseDate(value))}
                allowClear={false}
                placeholder={t('selectMonth')}
              />
            </Form.Item>
            <Form.Item label={HARD_SPACE}>
              <Checkbox
                onChange={(e) => this.setFilterValue('showOnlyDiscrepancies', e.target.checked)}
                checked={filterDto.showOnlyDiscrepancies}
              >
                {t('showOnlyDiscrepancies')}
              </Checkbox>
            </Form.Item>
          </Col>
          <Col third>
            <Form.Item label={HARD_SPACE}>
              <Checkbox
                onChange={(e) => this.setFilterValue('combineLocations', e.target.checked)}
                checked={filterDto.combineLocations}
              >
                {t('combineLocations')}
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(Filter)
